import UsersPageContent from "src/components/Users/UsersPageContent";

const Users = () => {
  return <UsersPageContent type="user" />;
};

export default Users;
